import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { LOGIN_ROUTE } from "../../auth/constants";

export const Route = createFileRoute("/auth/error")({
  validateSearch: (search: Record<string, unknown>): { reason?: string } => ({
    reason: typeof search.reason === "string" ? search.reason : undefined,
  }),
  component: ErrorPage,
});

function ErrorPage() {
  const { reason } = Route.useSearch();
  const navigate = useNavigate();

  const isUnauthorized = reason === "unauthorized";

  return (
    <div style={{ textAlign: "center", padding: "2rem", maxWidth: 400 }}>
      <p style={{ fontSize: "1.25rem", fontWeight: 600, color: "#111827" }}>
        {isUnauthorized ? "Access Denied" : "Authentication Error"}
      </p>
      <p style={{ color: "#6b7280", marginTop: "0.5rem", fontSize: "0.875rem" }}>
        {isUnauthorized
          ? "You don't have permission to access this page."
          : (reason ?? "An unexpected error occurred during authentication.")}
      </p>
      <button
        onClick={() => {
          // Clear ROCP_* tokens and PKCE state from localStorage
          const ropKeys = Object.keys(localStorage).filter((k) => k.startsWith("ROCP_"));

          ropKeys.forEach((k) => localStorage.removeItem(k));
          sessionStorage.clear();
          void navigate({ to: LOGIN_ROUTE as string, replace: true });
        }}
        style={{
          marginTop: "1.5rem",
          padding: "0.5rem 1.25rem",
          backgroundColor: "#3b82f6",
          color: "#fff",
          border: "none",
          borderRadius: "0.375rem",
          cursor: "pointer",
          fontSize: "0.875rem",
        }}
      >
        {isUnauthorized ? "Back to Login" : "Try Again"}
      </button>
    </div>
  );
}
